import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { priceRegex } from "../helper/regex";
import { getPlaceList } from "../store/slices/places";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import { getcarType } from "../store/slices/carType";
import {
  getairportCarChargesList,
  putairportCarCharges,
} from "../store/slices/airportCarCharges";

const EditAirportCharges = () => {
  const { id } = useParams();
  const [vehicleErrors, setvehicleErrors] = useState([]);
  const [place, setPlace] = useState();
  const [placeList, setplaceList] = useState([]);
  const [carList, setcarList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const [vehicle, setVehicle] = useState([
    {
      id: Date.now(),
      vehicle: "",
      price: "",
    },
  ]);
  useEffect(() => {
    const fetchPlaceDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getairportCarChargesList(item)).unwrap();
        const place = data?.carData[0];

        setPlace(place.place.id || "");
        const clonedVehicleDetails = (place.vehicle || []).map(
          (item, index) => ({
            ...item,
            id: `${Date.now()}-${index}`,
          })
        );
        const initialvehicleErrors = clonedVehicleDetails.reduce(
          (errors, item) => {
            errors[item.id] = {
              vehicle: "",
              price: "",
            };
            return errors;
          },
          {}
        );
        setvehicleErrors(initialvehicleErrors);
        setVehicle(clonedVehicleDetails);
      } catch (error) {
        console.error("Failed to fetch amenity details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlaceDetails();
  }, [dispatch, id]);

  const handleAddpackage = (e) => {
    e.preventDefault();

    const newId = Date.now().toString();

    const isDuplicate = vehicle.some((item) => item.vehicle === "");

    if (isDuplicate) {
      alert(
        "Please select a vehicle for the existing row before adding a new one."
      );
      return;
    }

    setVehicle((prevVehicle) => [
      ...prevVehicle,
      { id: newId, vehicle: "", price: "" },
    ]);

    setvehicleErrors((prevErrors) => ({
      ...prevErrors,
      [newId]: { vehicle: "", price: "" },
    }));
  };

  const handleRemovepackage = (id, e) => {
    e.preventDefault();

    setVehicle((prevVehicle) => prevVehicle.filter((q) => q.id !== id));

    setvehicleErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[id]; // Remove the deleted package from the errors object
      return updatedErrors;
    });
  };

  const handleInputChange = async (index, field, value) => {
    const updatedVehicle = [...vehicle];
    const updatedErrors = { ...vehicleErrors };

    if (!updatedErrors[vehicle[index].id]) {
      updatedErrors[vehicle[index].id] = { vehicle: "", price: "" };
    }

    if (field === "vehicle") {
      // Check if the vehicle is already selected
      const isDuplicate = updatedVehicle.some(
        (item, i) => item.vehicle === value && i !== index
      );

      if (isDuplicate) {
        updatedErrors[vehicle[index].id].vehicle =
          "This vehicle is already added!";
      } else {
        updatedErrors[vehicle[index].id].vehicle =
          value.trim() === "" ? "Please select a vehicle" : "";
        updatedVehicle[index][field] = value;
      }
    }

    if (field === "price") {
      const sanitizedPrice = value.replace(/\D/g, "").slice(0, 5);
      updatedVehicle[index][field] = sanitizedPrice;
      updatedErrors[vehicle[index].id].price =
        sanitizedPrice === "" || !priceRegex.test(sanitizedPrice)
          ? "Please enter a valid price"
          : "";
    }

    setvehicleErrors(updatedErrors);
    setVehicle(updatedVehicle);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "place") {
      setPlace(value);
      validationErrors.place =
        value.trim() === "" ? "Please select a place" : "";
    }

    setErrors(validationErrors);
  };

  const validateForm = () => {
    let newErrors = {};

    // Places Validation
    if (!place || place.trim() === "") {
      newErrors.place = "Please select a place";
    }

    // package Validation
    const vehicleErrors = vehicle.map((item) => ({
      vehicle: item.vehicle === "" ? "Please select vehicle" : "",
      price: item.price === "" ? "Please enter price" : "",
    }));
    setvehicleErrors(vehicleErrors);

    // Check for any package errors
    if (vehicleErrors.some((err) => err.vehicle || err.price)) {
      newErrors.tourIternary = "Please fix errors in the package section";
    }

    // Finally set all errors in the state
    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      vehicleErrors.every((err) => !err.vehicle && !err.price);

    return isValid;
  };

  const addPackage = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }

    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      isActive: 1,
      isApproved: 1,
      vehicle,
      isSpecial: 0,
      place,
      id,
    };

    try {
      await dispatch(putairportCarCharges(item)).unwrap();
      alert("Price edited successfully!");
      navigate("/admin/airport-charges");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        setplaceList(data?.placesData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getcarType())
      .unwrap()
      .then((data) => {
        setcarList(data?.carData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Price</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Airport Pickup Drop Price
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Price</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Place<span className="text-danger">*</span>
                </label>
                <select
                  name="place"
                  value={place}
                  onChange={handleChange}
                  className={`form-control ${errors.place ? "is-invalid" : ""}`}
                >
                  <option value="">Select</option>
                  {placeList?.map((placedata) => (
                    <option key={placedata._id} value={placedata._id}>
                      {placedata.name}
                    </option>
                  ))}
                </select>
                {errors.place && (
                  <div className="text-danger mt-2">{errors.place}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {vehicle.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddpackage}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={(e) => handleRemovepackage(item.id, e)}
                          disabled={vehicle.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Vehicle Name <span className="text-danger">*</span>
                          </label>
                          <select
                            name="vehicle"
                            value={item.vehicle.id}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "vehicle",
                                e.target.value
                              )
                            }
                            className={`form-control ${
                              vehicleErrors[item.id]?.vehicle
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option value="">Select Vehicle</option>
                            {carList?.map((car) => (
                              <option key={car._id} value={car._id}>
                                {car.carName}
                              </option>
                            ))}
                          </select>
                          {vehicleErrors[item.id]?.vehicle && (
                            <div className="text-danger mt-2">
                              {vehicleErrors[item.id]?.vehicle}
                            </div>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">
                            Price
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="priceperPerson"
                            value={item.price}
                            onChange={(e) =>
                              handleInputChange(index, "price", e.target.value)
                            }
                            className={`form-control ${
                              vehicleErrors[index]?.price ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Price"
                          />
                          {vehicleErrors[index]?.price && (
                            <div className="text-danger mt-2">
                              {vehicleErrors[index]?.price}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditAirportCharges;
